import React, {useEffect, useRef, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretDown, faCaretUp, faFileDownload, faPlusCircle} from "@fortawesome/free-solid-svg-icons";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
  PaginationTotalStandalone
} from "react-bootstrap-table2-paginator";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {Link} from "react-router-dom";
import {focusById, onKeyDownNext, onKeyDownShortCut} from "./CMUtil";
// import overlayFactory from 'react-bootstrap-table2-overlay';

export const MdDatatable = ({
                              keyField,
                              listData,
                              columns,
                              loading,
                              onTableChange,
                              page,
                              sizePerPage,
                              totalSize,
                              showPagenation,
                              linkToAdd,
                              noDataIndication,
                              selectedRowId,
                              onKeyDownCtlEnterDataList,
                              onKeyDownEscDataList,
                              onKeyDownSpaceDataList
                            }) => {

  const init1 = useRef(true);
  const init2 = useRef(true);

  const [paginationOption, setPaginationOption] = useState({totalSize: 0});
  const [data, setData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]); // 2行目を初期選択 [web:22]
  const selectRow = {
    mode: 'radio',      // 'checkbox' で複数選択, 'radio' で単一選択 [web:22][web:26]
    clickToSelect: true,    // 行クリックで選択ON/OFF [web:22][web:26]
    hideSelectColumn: true,
    selected: selectedIds,
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedIds([row.row_id]);
      } else {
        setSelectedIds([]);
      }
    },
    bgColor: '#DBE5F5'
  };

  useEffect(() => {

    if (init1.current) {
      init1.current = false;
      return;
    }

    const iPaginationOption = {
      bootstrap4: true,
      page: page ? page : 1,
      sizePerPage: sizePerPage ? sizePerPage : 50,
      totalSize: listData ? listData.count : 0,
      paginationTotalRenderer: (from, to, size) => {
        return (
          <span className="react-bootstrap-table-pagination-total">
        全 {size} 件中 {from} ～ {to} 件表示
        </span>
        )
      },
      showTotal: true,
      withFirstAndLast: true,
      alwaysShowAllBtns: true,
      firstPageText: '<<',
      prePageText: '<',
      nextPageText: '>',
      lastPageText: '>>'
    };
    setPaginationOption(iPaginationOption);

    if (listData.results) {
      setData(listData.results);
    }
  }, [listData])

  useEffect(() => {
    if (init2.current) {
      init2.current = false;
      return;
    }
    setSelectedIds([selectedRowId]);
  }, [selectedRowId])

  const NoDataIndication = () => (
    <span>登録情報はありません</span>
  );

  // ショートカットキー /////////////////////////////////////////////////////////////////////////////////
  // Ctl＋Enter
  const onKeyDownCtlEnter = async (e) => {
    if (onKeyDownCtlEnterDataList) {
      e.preventDefault();
      e.selected = selectRow.selected;
      onKeyDownCtlEnterDataList(e);
    }
  }

  // Escape
  const onKeyDownEsc = async (e) => {
    if (onKeyDownEscDataList) {
      e.preventDefault();
      e.selected = selectRow.selected;
      onKeyDownEscDataList(e);
    }
  }

  // Space
  const onKeyDownSpace = async (e) => {
    if (onKeyDownSpaceDataList) {
      e.preventDefault();
      e.selected = selectRow.selected;
      onKeyDownSpaceDataList(e);
    }
  }

  // Enter
  const onKeyDownEnter = async (e) => {
    e.preventDefault();
    let currentIndex = data.findIndex(r => r.row_id === selectRow.selected[0]);
    if (e.shiftKey) {
      setSelectedIds([data[currentIndex - 1].row_id]);
    } else {
      setSelectedIds([data[currentIndex + 1].row_id]);
    }
  }

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOption)}>
        {
          ({
             paginationProps,
             paginationTableProps
           }) => (
            <div
              id="data-table"
              tabIndex={0}

              onKeyDown={(e) => onKeyDownShortCut(e, null, () => onKeyDownCtlEnter(e), () => onKeyDownEsc(e), () => onKeyDownSpace(e), () => onKeyDownEnter(e))}
            >
              <Row>
                {showPagenation &&
                  <Col sm="3" style={{marginTop: ".5rem"}}>
                    <PaginationTotalStandalone {...paginationProps} />
                  </Col>
                }
                {showPagenation &&
                  <Col sm="6" className="justify-content-md-center">
                    <PaginationListStandalone {...paginationProps} />
                  </Col>
                }
                {linkToAdd &&
                  <Col sm="3" className="text-right">
                    <Button as={Link} variant="add" to={linkToAdd}>
                      <FontAwesomeIcon icon={faPlusCircle} size="lg"/>
                      追加
                    </Button>
                  </Col>
                }
              </Row>
              <BootstrapTable
                remote
                responsive
                keyField={keyField}
                classes="dm-datatable"
                striped={true}
                data={data}
                columns={columns}
                onTableChange={onTableChange}
                selectRow={selectRow}
                {...paginationTableProps}
                // loading={false}
                // overlay={overlayFactory({spinner: true, styles: {overlay: (base) => ({...base, background: 'rgba(255, 255, 255, 0.5)'})}})}
                noDataIndication={() => <NoDataIndication/>}
              />
              {showPagenation && <PaginationListStandalone {...paginationProps} />}
              {showPagenation && <PaginationTotalStandalone {...paginationProps} />}
            </div>
          )
        }
      </PaginationProvider>
    </>
  )
};

export default MdDatatable;

export function sortCaret(order, column) {
  if (order === "asc") {
    return (
      <>
        <FontAwesomeIcon icon={faCaretUp} size="lg" style={{marginLeft: '5px'}}/>
      </>
    )
  } else if (order === "desc") {
    return (
      <>
        <FontAwesomeIcon icon={faCaretDown} size="lg" style={{marginLeft: '5px'}}/>
      </>
    )
  } else {
    return (
      <>
      </>
    )
  }
}

export const InitialLoading = ({loadingCss}) => {

  return (
    <div className={loadingCss}>
      <div className="_loading_overlay_spinner css-50etie">
        <svg viewBox="25 25 50 50">
          <circle style={{strokeWidth: "2", fill: "none", strokeMiterlimit: "10"}} cx="50" cy="50" r="20"></circle>
        </svg>
      </div>
    </div>
  )
}